import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
              We also custom tailor your investment strategies to clients’ specific needs.
          </h5>
          <h5 className={classes.description}>We develop ideas and analysis that drive new perspectives, new opportunities and new paths to growth.</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="OWNERS"
            description={
              <span>
                <p>
                  We help realize the potential of your real estate assets by assisting with:
                  * Development decisions
                  * Lease management
                  * Purchase decisions and process
                  * Sale decisions and process
                  Our leasing professionals provide strategic expertise to commercial property owners and investors, working to:
                  * Maximize awareness in the marketplace
                  * Stabilize occupancy through leasing and tenant retention
                  * Achieve optimal rents
                  * Enhance investment value
                  Our dual goal is to realize client real estate objectives and investment criteria and to develop relationships that result in long-term partnerships.
</p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="OCCUPIERS"
            description={
              <span>
                <p>
                  Our experts help tenants identify strategic business, financial, and operational objectives, and align them with real estate requirements by utilizing our in-depth knowledge of global markets, strategic problem-solving abilities, and experience.
                  Tenant representation services include:
                  * Strategy development
                  * Build-to-suit planning
                  * Demographic analysis
                  * Logistic/distribution services
                  * Market analysis
                  * Cost of occupancy analysis
                  * Negotiations
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="INVESTORS"
            description={
              <span>
                <p>
                  If you are in the market for a real estate investment opportunity, contact us here. You can meet with a broker for these specific types of real estate investments and discuss what type of criteria and return you are looking for. If you are looking to sell investment property, an broker real estate investment broker can help with that too.</p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="RELATIONSHIPS"
            description={
              <span>
                <p>
                  Brokerage and investment advisory relationships.
                  The Brokerage World Is Changing but continue more important is relations.
                  Building Trust
                  Trust is the foundation of every business relationship, and real estate is no exception. On the home buying side, the National Association of Realtors found that honesty and trust were the top factors for buyers when choosing which agent to work with; It’s the same with respect to commercial real estate.
</p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
          <h3 className={classes.title}>Investment strategies</h3>
            <span>
              <p>
                <h5>Management of JV or Development Process</h5>
                <h5>Financial Operating Modelling</h5>
                <h5>Budgeting and control</h5>
                <h5>Legal Structuring and Specifications</h5>
                <h5>Tech-Enabled Interaction</h5>
                <h5>Financial Reporting</h5>
                <h5>Operation Reporting</h5>
                <h5>Marketing Strategy</h5>
                <h5>Sales Strategy</h5>
                <h5>Life Cycle Cost Analysis</h5>
                <h5>Asset Positioning</h5>
                <h5>Exit Strategy</h5>
              </p>

            </span>
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
          <h3 className={classes.title}>Investment channels</h3>
            <span>

                <h6>Direct Investments</h6>
                <h5>In real estate assets </h5>
                <h5>In projects</h5> 
                <h6>Through Intermediaries</h6>
                <h5>InvestmentManagers </h5>
                <h5>Private equity funds </h5>
                <h5>Infrastructure funds</h5> 
                <h5>Socimis</h5> 
                <h5>Reits</h5> 
                <h6>Other pooled investment vehicles...</h6>

            </span>
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(servicesStyle)(SectionServices);
